<template>
  <div class="flex flex-wrap gap-8">
    <span
      v-if="article.author"
      class="raw-body-3 rounded-full flex h-24 items-center bg-[white]/40 px-8"
    >
      <span class="line-clamp-1">
        {{ i18n(translations.words, { author: article.author }) }}
      </span>
    </span>
    <span
      v-if="article.region[0]"
      class="raw-body-3 rounded-full flex h-24 items-center bg-[white]/40 px-8"
    >
      <RegionLabel :region="article.region[0]" />
    </span>

    <slot />

    <!-- Full-width row so the metal button breaks onto its own line. -->
    <div class="flex w-full">
      <button
        type="button"
        class="raw-body-3 rounded-full flex h-24 items-center gap-8 bg-[white]/40 p-2 ps-8 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] hover:bg-[color-mix(in_oklab,var(--raw-lightgrey)_75%,transparent)] active:bg-[color-mix(in_oklab,var(--raw-lightgrey)_75%,transparent)]"
        @click="openMetal()"
      >
        <span class="line-clamp-1">
          {{ i18n(article.metal.name) }}
        </span>
        <RevIllustration
          src="/mine-my-phone/icons/right--flat.svg"
          alt=""
          aria-hidden="true"
          :width="20"
          :height="20"
          class="rounded-full bg-[white] p-4"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'

import RegionLabel from '~/scopes/campaign/components/impacts/RegionLabel.vue'
import { useModalState } from '~/scopes/campaign/composables/useModalState'
import type { Article } from '~/scopes/campaign/data/articles/data'

import translations from './ArticleMeta.translations'

const props = defineProps<{
  article: Article
  /** Tracking surface of the host view — panel or reader. */
  zone: string
}>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { openMetalQuickView } = useModalState()

function openMetal() {
  const { slug } = props.article.metal
  trackClick({ zone: props.zone, name: `metal-chip-${slug}` })
  openMetalQuickView(slug)
}
</script>
